// extracted by mini-css-extract-plugin
module.exports = {"fileName":"uploadDocument_fileName__18u8q","file_name":"uploadDocument_file_name__3oKXz","final_status":"uploadDocument_final_status__144gg"};